import FormatData from "../formatters/FormatBase64"

export default function printPdf(data: string) {
    const fileData = new Blob([FormatData(data)], { type: "application/pdf" })
    const fileURL = URL.createObjectURL(fileData)
    window.open(fileURL)
}
export  function showPdf(data: string) {
    const fileData = new Blob([FormatData(data)], { type: "application/pdf" })
    const fileURL = URL.createObjectURL(fileData)
    window.location.replace(fileURL)
}
